import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { ReactNode } from 'react'

interface ContentContainerProps {
  children: ReactNode,
  width?: number
}

const ContainerBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'width',
})<{ width?: number }>(({ width }) => ({
  width: `${width ?? 80}%`,
  maxWidth: 1440,
  marginLeft: 'auto',
  marginRight: 'auto',
}))

const ContentContainer = ({ children, width }: ContentContainerProps) => {
  return <ContainerBox width={width}>{children}</ContainerBox>
}

export default ContentContainer
